import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routesRj from "routesRJ";
import routesDsa from "routesDSA.js";
import routesHarmos from "routesHarmos.js";
import routesTo from "routesTO"
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import bgImage2 from "assets/img/sidebar-7.jpeg";
import bgImage3 from "assets/img/sidebar-6.jpeg";
import bgImage4 from "assets/img/sidebar-9.jpeg";
import bgImage5 from "assets/img/sidebar-10.jpeg";
import bgImage6 from "assets/img/sidebar-11.png";
import bgImage8 from "assets/img/sidebar-8.png";
import bgImage9 from "assets/img/sidebar-13.png";
import bgImage10 from "assets/img/sidebar-14.png";
import bgImageHarmos from "assets/img/sidebar-harmos.png";
import bgImage11 from "assets/img/meu_alho.jpg";

import logo from "assets/img/reactlogo.png";
import useAuth from "hooks/useAuth";

let ps;
const switchRoutesRj = (
  <Switch>
    {routesRj.map((prop, key) => {
      return (
        <Route
          path={(prop.layout || "") + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}
    <Redirect from="/admin" to="/admin/dashboard" />
    <Redirect from="/material-dashboard-react" to="/admin/dashboard" />
  </Switch>
);
const switchRoutesHarmos = (
  <Switch>
    {routesHarmos.map((prop, key) => {
      return (
        <Route
          path={(prop.layout || "") + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}
    <Redirect from="/admin" to="/admin/dashboard" />
    <Redirect from="/material-dashboard-react" to="/admin/dashboard" />
  </Switch>
);
const switchRoutesTo = (
  <Switch>
    {routesTo.map((prop, key) => {
      return (
        <Route
          path={(prop.layout || "") + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}
    <Redirect from="/admin" to="/admin/dashboard" />
    <Redirect from="/material-dashboard-react" to="/admin/dashboard" />
  </Switch>
);
const switchRoutesDsa = (
  <Switch>
    {routesDsa.map((prop, key) => {
      return (
        <Route
          path={(prop.layout || "") + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}
    <Redirect from="/admin" to="/admin/dashboard" />
    <Redirect from="/material-dashboard-react" to="/admin/dashboard" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  // styles
  const { storageId, garlicType } = useAuth();
  const classes = useStyles();

  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  const mainPanelGarlic = React.createRef();
  // states and functions

  let image = bgImage; // aqui que se muda a imagem de trás
  let color = "red";
  if (storageId === 1 || storageId === 5 || storageId === 6) {
    image = bgImage4;
  }
  if (storageId === 2) {
    image = bgImage2;
  }
  if (storageId === 3) {
    image = bgImage5;
  }
  if (garlicType === true) {
    image = bgImage11;
  }
  if (storageId === 7) {
    image = bgImage6;
  }
  if (storageId === 8) {
    image = bgImage8;
  }
  if (storageId === 10) {
    image = bgImage9;
  }
  if (storageId === 11) {
    image = bgImage10;
  }
  if (storageId === 18) {
    image = bgImageHarmos;
  }
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      if (garlicType === true) {
        ps = new PerfectScrollbar(mainPanelGarlic.current, {
          suppressScrollX: true,
          suppressScrollY: false,
        });
      } else {
        ps = new PerfectScrollbar(mainPanel.current, {
          suppressScrollX: true,
          suppressScrollY: false,
        });
      }
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

const getAdminRouteSidebar = () => {
  switch (storageId) {
    case 3:
      return switchRoutesRj;
    case 18:
      return switchRoutesHarmos;
    case 19:
      return switchRoutesTo;
    default:
      return switchRoutesDsa;
  }
}
const getAdminRouteNavibar = () => {
  switch (storageId) {
    case 3:
      return routesRj;
    case 18:
      return routesHarmos;
    case 19:
      return routesTo;
    default:
      return routesDsa;
  }
}

  return (
    <>
      <div className={classes.wrapper}>
        <Sidebar
          routes={getAdminRouteNavibar()}
          logoText={""}
          logo={logo}
          image={image}
          handleDrawerToggle={handleDrawerToggle}
          open={mobileOpen}
          color={color}
          {...rest}
        />
        <div className={garlicType === true ? classes.mainPanelGarlic : classes.mainPanel} ref={garlicType === true ? mainPanelGarlic : mainPanel}>
          <Navbar
            routes={getAdminRouteNavibar()}
            handleDrawerToggle={handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{getAdminRouteSidebar()}</div>
            </div>
          ) : (
            <div className={classes.map}>{getAdminRouteSidebar()}</div>
          )}
          {getRoute() ? <Footer /> : null}
        </div>
      </div>

    </>
  );
}
